import { Rating, RatingProps } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';

export const CustomRating = (props: RatingProps) => {
  const icon = <StarIcon fontSize="inherit" />;
  return (
    <Rating 
      {...props}
      icon={icon}
      emptyIcon={icon}
    />
  );
};